import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Right-aligned actions (buttons, etc.). */
  actions?: React.ReactNode;
}

/**
 * Standard page heading: large tracked title + optional subtitle on the left,
 * actions on the right. Used across the redesigned pages for consistency.
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <div className="ui-page-header">
    <div className="ui-page-header__titles">
      <h1 className="ui-page-header__title">{title}</h1>
      {subtitle && <div className="ui-page-header__subtitle">{subtitle}</div>}
    </div>
    {actions && <div className="ui-page-header__actions">{actions}</div>}
  </div>
);

export default PageHeader;
